"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
const HorizontalRule = ({
  className,
  children,
  lineStyle,
  position
}) => {
  const classes = (0, _classnames.default)('HorizontalRule', `HorizontalRule-${lineStyle}`, `HorizontalRule-${position}`, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, /*#__PURE__*/_react.default.createElement("span", null, children));
};
HorizontalRule.defaultProps = {
  lineStyle: 'solid',
  position: 'center'
};
var _default = exports.default = HorizontalRule;